import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { MonthlyData } from '@/hooks/useAdminChartData';

interface UserGrowthChartProps {
  data: MonthlyData[];
}

export const UserGrowthChart = ({ data }: UserGrowthChartProps) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
        <XAxis 
          dataKey="month" 
          stroke="#6b7280"
          style={{ fontSize: '12px' }}
        />
        <YAxis 
          stroke="#6b7280"
          style={{ fontSize: '12px' }}
        />
        <Tooltip 
          contentStyle={{
            backgroundColor: '#ffffff',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
          }}
        />
        <Legend 
          wrapperStyle={{ fontSize: '14px' }}
        />
        <Line 
          type="monotone" 
          dataKey="totalUsers" 
          stroke="#3b82f6" 
          strokeWidth={2}
          name="総ユーザー数" 
          dot={{ fill: '#3b82f6', r: 4 }}
          activeDot={{ r: 6 }}
        />
        <Line 
          type="monotone" 
          dataKey="newUsers" 
          stroke="#10b981" 
          strokeWidth={2}
          name="新規ユーザー" 
          dot={{ fill: '#10b981', r: 4 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

interface PlanDistributionChartProps {
  data: MonthlyData[];
}

export const PlanDistributionChart = ({ data }: PlanDistributionChartProps) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
        <XAxis 
          dataKey="month" 
          stroke="#6b7280"
          style={{ fontSize: '12px' }}
        />
        <YAxis 
          stroke="#6b7280"
          style={{ fontSize: '12px' }}
        />
        <Tooltip 
          contentStyle={{
            backgroundColor: '#ffffff',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
          }}
        />
        <Legend 
          wrapperStyle={{ fontSize: '14px' }}
        />
        <Bar 
          dataKey="freeUsers" 
          fill="#f97316" 
          name="無料プラン"
          radius={[4, 4, 0, 0]}
        />
        <Bar 
          dataKey="proUsers" 
          fill="#a855f7" 
          name="Proプラン"
          radius={[4, 4, 0, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};
